<template>
  <md-card
    :class="{ 'md-card-plain': plain }"
    class="md-card-timeline">
    <ul
      :class="{ 'timeline-simple': type === 'simple' }"
      class="timeline">
      <slot/>
    </ul>
  </md-card>
</template>
<script>
export default {
  name: "TimeLine",
  props: {
    plain: Boolean,
    type: {
      type: String,
      default: ""
    }
  }
};
</script>
<style></style>
